import React, { useEffect, useId, useState } from 'react';
import { fiscalService } from '../../services/fiscalService';

interface CfopItem {
  codigo: string;
  descricao: string;
}

let cachePromise: Promise<CfopItem[]> | null = null;

function normalizarCfops(raw: any): CfopItem[] {
  const lista = Array.isArray(raw) ? raw : raw?.cfops || raw?.data || [];
  return lista
    .map((item: any) => ({
      codigo: String(item.codigo ?? item.cfop ?? ''),
      descricao: String(item.descricao ?? item.nome ?? ''),
    }))
    .filter((c: CfopItem) => c.codigo);
}

function carregarCfops(): Promise<CfopItem[]> {
  if (!cachePromise) {
    cachePromise = fiscalService
      .consultarCfopFocus()
      .then(normalizarCfops)
      .catch((e) => {
        console.warn('Erro ao consultar CFOPs na Focus NFe:', e);
        return [];
      });
  }
  return cachePromise;
}

interface CfopAutocompleteProps {
  value: string;
  onChange: (codigo: string) => void;
  /** Chamado com a descrição oficial (Focus NFe) sempre que o código digitado/selecionado bate com um CFOP conhecido. */
  onSelectDescricao?: (descricao: string) => void;
  className?: string;
  placeholder?: string;
}

export function CfopAutocomplete({ value, onChange, onSelectDescricao, className, placeholder }: CfopAutocompleteProps) {
  const [opcoes, setOpcoes] = useState<CfopItem[]>([]);
  const listId = useId();

  useEffect(() => {
    let cancelado = false;
    carregarCfops().then((lista) => {
      if (!cancelado) setOpcoes(lista);
    });
    return () => {
      cancelado = true;
    };
  }, []);

  const selecionado = opcoes.find((c) => c.codigo === value);

  return (
    <div>
      <input
        type="text"
        list={listId}
        value={value}
        onChange={(e) => {
          const codigo = e.target.value.replace(/\D/g, '').slice(0, 4);
          onChange(codigo);
          const match = opcoes.find((c) => c.codigo === codigo);
          if (match && onSelectDescricao) onSelectDescricao(match.descricao);
        }}
        placeholder={placeholder || '5353'}
        className={className}
      />
      <datalist id={listId}>
        {opcoes.map((c) => (
          <option key={c.codigo} value={c.codigo}>{c.descricao}</option>
        ))}
      </datalist>
      {selecionado && (
        <span className="text-3xs text-slate-400 mt-0.5 block truncate">{selecionado.descricao}</span>
      )}
    </div>
  );
}
